/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 15:48
 * Desc: 主要客户或供应商发生变更
 */
import styles from '../../../common/common.scss';
import React from 'react';
import cns from 'classnames';
import { Table } from 'antd';
import { fieldAnomaly } from '../../../../../utils/formatter';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import { checkSearch } from '../../../common/commons';

export default class ClientSupplierChange extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.companyInfo = checkSearch();
        this.state = {
            loading: false,
            customerData: [],
            supplierData: []
        };
    }

    formatResponse = (data) => {
        data = data || {};
        return {
            customerData: this.formatListData(data.customerList, 'customer'),
            supplierData: this.formatListData(data.supplierList, 'supplier')
        };
    };

    formatListData = (data, field = 'customer') => {
        let { reportYear } = this.companyInfo;
        let result = [[], []];

        data && data.forEach(d => {
            if (d[field + 'Name']) {
                let index = d.reportYear - reportYear + 1;
                let row = d.rowNum - 1;
                let obj = {};

                obj['index'] = row;
                obj['name'] = d[field + 'Name'];
                obj['amount'] = d[field + 'Amout'];

                result[index].push(obj);
            }
        });

        return result;
    };

    // 上年
    getColumns = (year = this.companyInfo.reportYear, amount = '采购额') => {

        return [ {
            title: year,
            dataIndex: 'name',
            render: fieldAnomaly
        }, {
            title: amount,
            dataIndex: 'amount',
            width: 150,
            render: fieldAnomaly
        }];
    };

    render() {
        const { loading, customerData, supplierData } = this.state;
        const { reportYear } = this.companyInfo;
        const preYear = reportYear - 1;

        return (
            <div>
                <div className="sub-title">前五名供应商情况</div>
                <div className={cns(styles.doubleTable, 'clearfix')}>
                    <Table
                        bordered
                        rowKey="index"
                        loading={loading}
                        dataSource={supplierData[0]}
                        columns={this.getColumns(preYear)}
                        pagination={false}
                    />
                    <Table
                        bordered
                        rowKey="index"
                        loading={loading}
                        dataSource={supplierData[1]}
                        columns={this.getColumns(reportYear)}
                        pagination={false}
                    />
                </div>

                <div className="sub-title">前五名客户情况</div>
                <div className={cns(styles.doubleTable, 'clearfix')}>
                    <Table
                        bordered
                        rowKey="index"
                        loading={loading}
                        dataSource={customerData[0]}
                        columns={this.getColumns(preYear, '销售额')}
                        pagination={false}
                    />
                    <Table
                        bordered
                        rowKey="index"
                        loading={loading}
                        dataSource={customerData[1]}
                        columns={this.getColumns(reportYear, '销售额')}
                        pagination={false}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/ClientSupplierChange.jsx